var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"white--text mt-1",attrs:{"x-small":"","color":"success"},on:{"click":_vm.sendVerifyEmail}},[_vm._v(" Doğrulama E-Postasını Gönder ")])
}
var staticRenderFns = []

export { render, staticRenderFns }